import { render, staticRenderFns } from "./ReportMetaPeople.vue?vue&type=template&id=04929bb1&"
import script from "./ReportMetaPeople.vue?vue&type=script&lang=js&"
export * from "./ReportMetaPeople.vue?vue&type=script&lang=js&"
import style0 from "./ReportMetaPeople.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports